// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1WAFN","inputWrap":"Table_inputWrap__2cuaq","col":"Table_col__1yb0K","bmiTooltip":"Table_bmiTooltip__3oAYM"};